import { trimLeadingSlash, trimTrailingSlash } from '@ms/yammer-libs-url-path-support';

export const combinePath = (parentPath: string, childPath: string) =>
  `${trimTrailingSlash(parentPath)}/${trimLeadingSlash(childPath)}`;
